/**
 * Converts multiple consecutive spaces in HTML to &nbsp;
 *
 * @param html The HTML string with potential multiple spaces
 * @returns HTML with multiple spaces converted to &nbsp;
 */
export const preserveSpacesForTurndown = (html: string): string => {
  if (!html) {
    return '';
  }

  return html.replace(/  +/g, (match) => {
    return '&nbsp;'.repeat(match.length);
  });
};

/**
 * Converts non-breaking spaces back to regular spaces
 *
 * @param text The text with potential nbsp characters
 * @returns Text with nbsp converted to regular spaces
 */
export const convertNbspToSpace = (text: string): string => {
  if (!text) {
    return '';
  }

  return text.replace(/\u00A0|\u202F|&nbsp;/g, ' ');
};
